import { create } from 'zustand'
import type { ScanBusinessCardResponse } from '../../../../hooks/api/mutations/ghostProfile/useScanBusinessCard'

// Hands a camera scan (CardScanner) over to the ImportContacts review form,
// so both entry points end on the same « Valider » step. Kept out of the
// route params so the parsed contact details never land in the web URL.
interface PendingCardScanState {
  pending: ScanBusinessCardResponse | null
  setPending: (scan: ScanBusinessCardResponse) => void
  take: () => ScanBusinessCardResponse | null
}

export const usePendingCardScanStore = create<PendingCardScanState>((set, get) => ({
  pending: null,
  setPending: (scan) => set({ pending: scan }),
  take: () => {
    const scan = get().pending
    if (scan) set({ pending: null })
    return scan
  },
}))
